"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const styles = ({ shape, palette, applyOpacityToHex, mixins }) => ({
    billMenu: {
        padding: 0,
    },
    billMenuItem: {
        borderRadius: shape.borderRadius,
        padding: shape.padding[1],
    },
    recurringMenuPaper: {
        borderRadius: shape.borderRadius * 2,
    },
    dialogClasses: {
        fullWidth: {
            padding: '10 20 10 20',
            width: '95%',
            maxWidth: '95%',
        },
    },
    panel: {
        padding: '10px 20px 10px 20px',
        background: palette.background.paper,
        marginBottom: '9px',
        marginLeft: 10,
    },
    reduceWidth: {
        width: 'fit-content',
    },
    dialogPaper: {
        width: '100%',
    },
    flexRow: {
        display: 'flex',
    },
    flexCol: {
        display: 'flex',
        flexDirection: 'column',
    },
    marginRight: {
        marginRight: 40,
    },
    detailsRow: {
        display: 'flex',
        marginBottom: 2,
    },
    whiteBg: {
        backgroundColor: palette.text.tertiary,
    },
    checkRow: {
        marginTop: 0,
    },
    attachRow: {
        display: 'flex',
        flex: 1,
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '6px 10px',
        margin: '8px 0',
        border: `1px solid ${palette.background.elevated}`,
        borderRadius: 4,
    },
    txfrRow: {
        marginTop: 15,
        textAlign: 'left',
        width: '100%',
    },
    rowIcon: {
        flex: 1,
        maxWidth: 39,
        marginTop: 'auto',
        marginBottom: 'auto',
        color: palette.text.tertiary,
        paddingBottom: 3,
    },
    fieldContainer: {
        flex: 1,
        maxWidth: 500,
    },
    bankInfoContainer: {
        flex: 1,
        marginTop: 5,
    },
    tagsFieldContainer: {
        marginBottom: 10,
    },
    bankInfoText: {
        color: palette.text.tertiary,
    },
    simpleEditContainer: {
        backgroundColor: 'unset',
        '&:hover': {
        // background: mixins.register.fieldHoverColor,
        },
        border: `1px solid ${palette.background.elevated}`,
        borderRadius: 4,
        padding: '6px 10px',
    },
    simpleTitles: {
        fontSize: mixins.register.fontSize.default,
        '&.add-top-margin': {
            marginTop: 10,
        },
    },
    simpleTextField: {
        width: '100%',
        marginTop: 0,
        '& input': {
            fontSize: mixins.register.fontSize.default,
            color: applyOpacityToHex(palette.text.strong, 0.6),
        },
        '&:focus-within': {
            background: palette.background.paper,
            '&:hover': {
                background: palette.background.paper,
            },
        },
    },
    textField: {
        background: palette.background.paper,
        paddingLeft: 0,
        paddingRight: 0,
        color: palette.text.primary,
        paddingBottom: '4px',
        paddingTop: 0,
        marginTop: '0px',
        width: '100%',
        fontSize: '13px',
        '& input': {
            padding: '0px',
            paddingBottom: '4px',
            fontSize: mixins.register.fontSize.default,
            paddingLeft: 0,
        },
        '&.nudge': {
            marginTop: '1px',
        },
    },
    webFirstContainer: {
        padding: '10px 16px',
        marginBottom: 10,
        borderRadius: 4,
        border: `1px solid ${palette.background.elevated}`,
    },
    detailsContainer: {
        marginBottom: 15,
        marginLeft: 4,
        marginRight: 40,
        background: palette.background.paper,
    },
    addDoc: {
        marginTop: 8,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        border: `1px solid ${palette.background.elevated}`,
        borderRadius: 4,
    },
    buttons: {
        color: palette.text.tertiary,
    },
    padAround: {
        marginBottom: 8,
        padding: '8px 4px',
    },
    buttonHolder: {
        textAlign: 'right',
        margin: 'auto',
        marginTop: '10px',
        background: palette.background.paper,
    },
    link: {
        fontSize: mixins.register.fontSize.large,
        verticalAlign: 'inherit',
        marginLeft: 4,
        textDecoration: 'underline',
        cursor: 'pointer',
        color: palette.link.main,
        '&:active': {
            background: palette.background.elevated,
        },
        '&:hover': {
            fontWeight: 'bold',
        },
        width: 'auto',
        textAlign: 'left',
        justifyContent: 'left',
    },
    checkboxField: {
        padding: 0,
        paddingRight: 10,
    },
    group: {
        border: `1px solid ${palette.background.elevated}`,
        borderRadius: 4,
        padding: 6,
        marginBottom: 8,
        backgroundColor: 'unset',
    },
    contentRow: {
        justifyContent: 'space-between',
        display: 'flex',
        alignItems: 'center',
        padding: '4px 8px',
        marginLeft: 0,
    },
    paper: {
        paddingTop: 20,
        paddingBottom: 20,
        paddingLeft: 60,
        paddingRight: 60,
        margin: 20,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: 20,
    },
    checkNumber: Object.assign({ width: 20, marginTop: -7, opacity: 0.6 }, (palette.mode === 'dark' && {
        filter: 'invert(1)',
    })),
    linkStyle: {
        textDecorationLine: 'none',
    },
});
exports.styles = styles;
